class GoogleTagManager extends Component {
    constructor(el) {
        super(el);

        this.registerEventListeners();
    }

    registerEventListeners() {
        EventBus.getInstance().addEventListener('homeSliderClicked', (e) => this.sendPromotionClick(e.detail.name, e.detail.id, 'HOMEPAGE'));
    }

    sendPromotionClick(name, id, location) {
        const event = {
            'event': 'ecc_promotion_click',
            'ecommerce': {
                'promoClick': {
                    'promotions': [
                        {
                            'id': id,
                            'name': name,
                            'position': location
                        }]
                }
            },
        };
        this.sendEvent(event);
    }

    sendEvent(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push(event);
    }

}
